export function buildTagDataAttr(tag) {
    var tagMapping = {
        eventCategory: "ec",
        eventLabel: "el",
        eventAction: "ea",
        eventType: "et",
        eventValue: "ev",
        event: "en"
    };
    return tag && // eslint-disable-next-line unicorn/prefer-object-from-entries
    Object.keys(tag).reduce(function(newTag, key) {
        var newKey = tagMapping[key] || key;
        newTag["data-".concat(newKey)] = tag[key];
        return newTag;
    }, {});
}
export default buildTagDataAttr;
